import React from "react";

function Committee() {
  return (
    <div className="container">
      <h2 className="section-title">2025/2026 Committee</h2>
      <div className="two-column">
        <div>
          <h3>Office Bearers</h3>
          <ul className="bullet-list">
            <li><strong>President:</strong> Satish Kumar Madda</li>
            <li><strong>Vice-President and Secretary:</strong> Rajesh Subramanian</li>
            <li><strong>Treasurer:</strong> Santhoshkumar Ranganathan</li>   
          </ul>
        </div>
        <div>
          <h3>Ordinary Committee Members</h3>
          <ul className="bullet-list">
            <li><strong>Member Protection Information Officer (MPIO):</strong> Tarun Malviya</li>
            <li><strong>Insurance Officer:</strong> Thilanka Kothalawala</li>
            <li><strong>Public Officer and Safety & First Aid Officer:</strong> Jagadeep Singh</li>
            <li><strong>Event Coordinator:</strong> Rajaram Thangavel</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Committee;
